<template>
  <LotteryBasePlaySlip>
    <template #default="{ isDisabled, isVisible, play, updatePlays }">
      <slot v-bind="{ isDisabled, isVisible, play, updatePlays }">
        <NumberLotteryBasePlaySlipItem
          v-if="isVisible || !isDisabled"
          v-bind="{ play }"
          class="pt-100"
          :disabled="isDisabled"
          @play-state-changed="updatePlays"
        />
        <LotteryPlaySlipItemSkeleton v-else height="20vh" />
      </slot>
    </template>

    <template #bottom>
      <slot name="bottom" />
    </template>
  </LotteryBasePlaySlip>
</template>
